import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
/** @jsxImportSource @emotion/react */
import { AnchorButton as BlueprintAnchorButton, Button as BlueprintButton, Tag, Tooltip, } from '@blueprintjs/core';
import { css } from '@emotion/react';
export function Button(props) {
    const { tooltipProps, children, tag, tagProps, ...buttonProps } = props;
    const InnerButton = buttonProps.disabled
        ? BlueprintAnchorButton
        : BlueprintButton;
    return (_jsx(Tooltip, { fill: tooltipProps?.fill || buttonProps.fill, ...tooltipProps, renderTarget: ({ isOpen, ...targetProps }) => (_jsxs("div", { style: { position: 'relative' }, children: [tag && (_jsx(Tag, { css: css `
                position: absolute;
                top: 0;
                left: 0;
                cursor: default;
                font-size: 0.875em;
                padding: 2px !important;
                min-height: 15px;
                min-width: 15px;
                line-height: 1em;
                text-align: center;
                z-index: 20;
              `, round: true, intent: "success", ...tagProps, children: tag })), _jsx(InnerButton, { ...targetProps, ...buttonProps, style: {}, children: children })] })) }));
}
//# sourceMappingURL=Button.js.map